import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Moon, Sun } from "lucide-react";
import { useApp } from "@/context/AppContext";

const links = [
  ["services", "#services"], ["tech", "#tech"], ["boats", "#boats"],
  ["area", "#area"], ["work", "#work"],
];

export default function Navbar() {
  const { t, theme, lang, toggleTheme, toggleLang } = useApp();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-[500] transition-all duration-300 ${scrolled ? (theme === "dark" ? "glass-dark" : "glass-light") : ""}`}
      data-testid="navbar"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[68px] flex items-center justify-between">
        <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-3 group" data-testid="logo">
          <img
            src="/logo-mne.png"
            alt="Marine Nav Electronics"
            className="h-9 md:h-10 w-auto object-contain drop-shadow-[0_2px_8px_rgba(0,150,199,0.35)] group-hover:scale-[1.03] transition-transform"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map(([key, href]) => (
            <a key={key} href={href} onClick={(e) => go(e, href)}
              className="font-mono text-xs tracking-[0.2em] uppercase hover:text-cyan transition-colors" data-testid={`nav-${key}`}>
              {t.nav[key]}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button onClick={toggleLang} data-testid="lang-toggle"
            className="font-mono text-xs px-3 py-2 border border-border rounded-full hover:border-cyan hover:text-cyan transition-colors">
            {lang === "en" ? "EN" : "ES"}
          </button>
          <button onClick={toggleTheme} data-testid="theme-toggle"
            className="p-2.5 border border-border rounded-full hover:border-cyan hover:text-cyan transition-colors">
            {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
          <a href="#contact" onClick={(e) => go(e, "#contact")} data-testid="nav-contact"
            className="hidden sm:inline-flex font-mono text-xs uppercase tracking-wider bg-cyan text-white px-5 py-2.5 rounded-full hover:bg-cyan/90 hover:glow-cyan transition-all">
            {t.nav.contact}
          </a>
        </div>
      </div>
    </motion.header>
  );
}
